import { render, staticRenderFns } from "./aLteAsideNavHeader.vue?vue&type=template&id=47f1da4a&functional=true"
import script from "./aLteAsideNavHeader.vue?vue&type=script&lang=js"
export * from "./aLteAsideNavHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('47f1da4a', component.options)
    } else {
      api.rerender('47f1da4a', component.options)
    }
    module.hot.accept("./aLteAsideNavHeader.vue?vue&type=template&id=47f1da4a&functional=true", function () {
      api.rerender('47f1da4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aside/aLteAsideNavHeader.vue"
export default component.exports